// Generated by ReScript, PLEASE EDIT WITH CARE

import * as EthersJs from "./Ethers.js";

function getLibraryVersion(prim) {
  return EthersJs.getLibraryVersion();
}

function getNetwork(prim) {
  return EthersJs.getNetwork(prim);
}

function getBlockNumber(prim) {
  return EthersJs.getBlockNumber(prim);
}

function getProvider(prim) {
  return EthersJs.getProvider(prim);
}

function toBigInt(prim) {
  return EthersJs.toBigInt(prim);
}

function addBigInt(prim0, prim1) {
  return EthersJs.addBigInt(prim0, prim1);
}

function subBigInt(prim0, prim1) {
  return EthersJs.subBigInt(prim0, prim1);
}

function equalBigInt(prim0, prim1) {
  return EthersJs.equalBigInt(prim0, prim1);
}

function greaterOrEqualBigInt(prim0, prim1) {
  return EthersJs.greaterOrEqualBigInt(prim0, prim1);
}

function newWalletFromPrivateKey(prim0, prim1) {
  return EthersJs.newWalletFromPrivateKey(prim0, prim1);
}

function getWalletBalance(prim) {
  return EthersJs.getWalletBalance(prim);
}

export {
  getLibraryVersion ,
  getNetwork ,
  getBlockNumber ,
  getProvider ,
  toBigInt ,
  addBigInt ,
  subBigInt ,
  equalBigInt ,
  greaterOrEqualBigInt ,
  newWalletFromPrivateKey ,
  getWalletBalance ,
}
/* ./Ethers.js Not a pure module */
